import { render, staticRenderFns } from "./LdpUserContent.vue?vue&type=template&id=a632e91e&scoped=true&"
import script from "./LdpUserContent.vue?vue&type=script&lang=js&"
export * from "./LdpUserContent.vue?vue&type=script&lang=js&"
import style0 from "./LdpUserContent.vue?vue&type=style&index=0&id=a632e91e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a632e91e",
  null
  
)

export default component.exports